module.exports = __webpack_public_path__ + "static/media/pic_zwdw2x.256ceae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/pic_zwdw2x.png
// module id = 317
// module chunks = 0